document.addEventListener("DOMContentLoaded", function () {
  const popovers = document.querySelectorAll("[data-popover]");

  popovers.forEach(function (popover) {
    const button = popover.querySelector(".popover-button");
    const content = popover.querySelector(".popover-content");

    function togglePopover() {
      const isExpanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", String(!isExpanded));
      content.hidden = isExpanded;
    }

    button.addEventListener("click", togglePopover);
    button.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        togglePopover();
      }
    });

    document.addEventListener("click", function (e) {
      if (!popover.contains(e.target)) {
        content.hidden = true;
        button.setAttribute("aria-expanded", "false");
      }
    });
  });
});
